import Vuex from '@/store/index'

export const isAuthorized = to => to.matched.some(route => (route.meta.loginRequired ? Vuex.getters['auth/userLoggedIn'] : true))
export const _ = undefined
